module.exports = __webpack_public_path__ + "static/media/css.2837e67f.svg";